<mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
(page)="pageChanged($event)" aria-label="Select page">
</mat-paginator>